var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable no-console */
import { injectable } from 'inversify';
import { Logger } from './logger';
let ConsoleLogger = class ConsoleLogger extends Logger {
    /**
     * Логирует сообщение об ошибке в Web console
     *
     * @param message - Сообщение об ошибке
     * @param options - Опции содержат данные, которые необходимо залогировать,
     * а так же level, определяющий степень серьезности ошибки и тип сообщения, которое будет выведено в Web console
     */
    log(message, { level, tags, context }) {
        switch (level) {
            case 'debug':
                console.log('Message: %O\nTags: %O\nContext: %O\n', message, tags, context);
                break;
            case 'info':
                console.info('Message: %O\nTags: %O\nContext: %O\n', { message }, tags, context);
                break;
            case 'warning':
                console.warn('Message: %O\nTags: %O\nContext: %O\n', { message }, tags, context);
                break;
            case 'error':
            case 'fatal':
                console.error('Message: %O\nTags: %O\nContext: %O\n', { message }, tags, context);
                break;
            default:
                console.log('Message: %O\nTags: %O\nContext: %O\n', { message }, tags, context);
        }
    }
};
ConsoleLogger = __decorate([
    injectable()
], ConsoleLogger);
export { ConsoleLogger };
